import { PiSortAscending, PiSortDescending } from 'react-icons/pi';

interface SortToggleProps {
  sortOrder: 'asc' | 'desc';
  onToggle: (order: 'asc' | 'desc') => void;
}

export const SortToggle = ({ sortOrder, onToggle }: SortToggleProps) => {
  return sortOrder === 'desc' ? (
    <PiSortDescending
      className="size-6 cursor-pointer"
      onClick={() => onToggle('asc')}
    />
  ) : (
    <PiSortAscending
      className="size-6 cursor-pointer"
      onClick={() => onToggle('desc')}
    />
  );
};
